<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              max-width="800px"
              scrollable
    >
        <v-card>
            <v-card-text v-if="item">
                <v-list two-line>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>Company</v-list-item-title>
                            <v-list-item-subtitle>{{item.name}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <div v-if="this.type && item[this.type].data.length">
                    <h3>Schemes</h3>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Address</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(scheme, index) in item[type].data" :key="index">
                                <td>{{ scheme.name }}</td>
                                <td>{{ scheme.address.full_address}}</td>
                                <td class="justify-center layout px-0">
                                    <v-icon @click="routeToEdit(scheme.id)"
                                            small
                                            class="mr-2"
                                    >
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon @click="routeToMap(scheme)" small title="View on map">
                                        mdi-google-maps
                                    </v-icon>
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>

            </v-card-text>
            <edit-scheme-dialog ref="editSchemeDialog"></edit-scheme-dialog>
        </v-card>
    </v-dialog>
</template>

<script>
	import EditSchemeDialog from '@/components/schemes/editSchemeDialog'

	export default {
		name: "companySchemesDialog",
        components: {
			EditSchemeDialog
        },
		data: () => ({
			dialog: false,
			id: null,
			item: null,
			type: null,
		}),
		methods: {
			routeToEdit(id) {
				this.$refs.editSchemeDialog.showDialog(id);
				// this.$router.push({name: 'companies.edit', params: {id: id}})
			},
			routeToMap(item) {
				this.$router.push({name: 'map', params: {scheme: item}})
			},
			showDialog: function (id, type) {
				this.dialog = true;
				this.id = id;
				this.type = type;
				this.getItem();
			},
			async getItem() {
				const {data} = await this.$http.get(`/companies/${this.id}`, {
					params: {
						include: `${this.type}.address`,
					}
				});

				this.item = data;
			},
			closeDialog: function () {
				this.dialog = false;
				this.id = null;
				this.item = null;
				this.type = null;
				this.$emit('closed');
			},
		},
	}
</script>

<style scoped>

</style>